import { Component, OnInit } from "@angular/core";
import { NgForm } from "@angular/forms";
import * as firebase from "firebase/app";
import "firebase/auth";
import { Router } from "@angular/router";
import { UsersService } from "../users/users.service";
import { RouteManagerService } from "../services/route-manager.service";

import { environment } from "../../environments/environment";

@Component({
    selector: "app-login",
    templateUrl: "./login.component.html",
    styleUrls: ["./login.component.scss"],
})
export class LoginComponent implements OnInit {
    warning: any;
    logged = true;
    version = environment.version;

    constructor(
        public router: Router,
        private usersService: UsersService,
        private routeManager: RouteManagerService
    ) { }

    ngOnInit() {
        firebase.auth().onAuthStateChanged(async user => {
            if (user) {
                const userData = await this.usersService.getUser(user.uid).toPromise();

                if (userData && userData.novoPerfil) {
                    if (userData.novoPerfil.permissoes.painel.length <= 0) {
                        this.router.navigateByUrl("/notpermited");
                    } else {
                        this.logged = true;

                        environment.user = userData;
                        environment.selected = userData.empresas[0];

                        const currentRoute = this.router.url;
                        const storedRoute = this.routeManager.getLastValidRoute();

                        if (this.routeManager.isValidRoute(currentRoute)) {
                            const updatedRoute = this.routeManager.updateRouteWithCnpj(currentRoute, environment.selected.cnpj);
                            if (updatedRoute !== currentRoute) {
                                this.router.navigateByUrl(updatedRoute);
                            }
                        }
                        else if (storedRoute && this.routeManager.isValidRoute(storedRoute)) {
                            const updatedRoute = this.routeManager.updateRouteWithCnpj(storedRoute, environment.selected.cnpj);
                            this.router.navigateByUrl(updatedRoute);
                        }
                        else {
                            this.router.navigateByUrl(`/dash/${environment.selected.cnpj}`);
                        }
                    }
                } else {
                    this.logged = false;

                    environment.user = null;
                    environment.selected = null;

                    this.router.navigateByUrl("/login");
                }
            } else {
                this.logged = false;

                environment.user = null;
                environment.selected = null;

                this.router.navigateByUrl("/login");
            }
        });
    }

    login(form: NgForm) {
        this.warning = { ok: true };
        firebase
            .auth()
            .signInWithEmailAndPassword(form.value.email, form.value.password)
            .catch(e => {
                if (e.code === "auth/invalid-email") {
                    this.warning = { error: "Endereço de email inválido" };
                }
                if (e.code === "auth/user-not-found") {
                    this.warning = { error: "Usuário não encontrado" };
                }
                if (e.code === "auth/user-disabled") {
                    this.warning = { error: "Usuário bloqueado" };
                }
                if (e.code === "auth/wrong-password") {
                    this.warning = { error: "Senha não corresponde ao usuário" };
                }
            });
    }
}
